import styled from "styled-components";

export const FlexBox = styled.div`
  display: flex;
  padding: 0.5% 0.5% 0.5% 5%;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    padding: 4% 3%;
  }

  div:nth-child(1) {
    img {
      width: 50px;
      @media (max-width: 768px) {
        width: 40px;
      }
    }
  }
  div:nth-child(2) {
    display: flex;
    align-items: center;
    gap: 10px;
    @media (max-width: 768px) {
      display: none;
    }
    div {
      display: flex;
      align-items: center;
      gap: 10px;
      padding:  5px 10px;
      border-radius: 5px;

      &:hover{
        background-color: #ccccccba;
        cursor: pointer;
        
      }
      img {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        object-fit: cover;
      }
      span {
        text-transform: capitalize;
        color: #000;
      }
    }
  }
  div:nth-child(3) {
    display: none;

    @media (max-width: 768px) {
      display: block;
      font-weight: 700;
      color: #000;
      text-transform: capitalize;
    }
  }
  div:nth-child(4) {
    display: none;

    @media (max-width: 768px) {
      display: flex;
      align-items: center;
      gap: 20px;
    }
  }
`;
